import { api } from "../api";
import { el } from "../lib/dom";
import { heroBand } from "../lib/ui";

/** The always-on feedback form — any signed-in user. Reached from the "Give
 *  feedback" nav link or the emailed request. Attribution + request-linking is
 *  handled server-side from the session, so no token is needed in the URL. */
export function renderFeedback(): HTMLElement {
  const root = el("main", { class: "page" });
  root.append(
    heroBand("Your take on", "Hub", "What's working, what isn't, and which apps you use (or don't)."),
  );
  const body = el("div", { class: "feedback-wrap" });
  root.append(body);

  let sentiment = 0;
  const senseBtns: HTMLButtonElement[] = [];
  const sense = el(
    "div",
    { class: "sentiment" },
    [1, 2, 3, 4, 5].map((n) => {
      const b = el("button", { type: "button", class: "sense-btn", "aria-label": `${n} of 5` }, [
        String(n),
      ]) as HTMLButtonElement;
      b.addEventListener("click", () => {
        sentiment = n;
        senseBtns.forEach((x, i) => x.classList.toggle("is-on", i < n));
      });
      senseBtns.push(b);
      return b;
    }),
  );

  const ta = (placeholder: string, rows = 3) =>
    el("textarea", { class: "control-input", rows: String(rows), placeholder }) as HTMLTextAreaElement;
  const likes = ta("What do you like? What's working well?");
  const improve = ta("What's frustrating or missing? What would you change?");
  const used = ta("Which apps do you use most?", 2);
  const notUsed = ta("Which apps do you not use — and why?", 2);

  const submit = el("button", { class: "btn btn-primary", type: "button" }, [
    "Submit feedback",
  ]) as HTMLButtonElement;
  const fb = el("p", { class: "muted-sm" });

  body.append(
    el("div", { class: "feedback-card" }, [
      el("label", { class: "control" }, [el("span", { class: "eyebrow" }, ["Overall (1–5)"]), sense]),
      el("label", { class: "control" }, [el("span", { class: "eyebrow" }, ["What you like"]), likes]),
      el("label", { class: "control" }, [el("span", { class: "eyebrow" }, ["What to improve"]), improve]),
      el("label", { class: "control" }, [el("span", { class: "eyebrow" }, ["Apps you use"]), used]),
      el("label", { class: "control" }, [
        el("span", { class: "eyebrow" }, ["Apps you don't use"]),
        notUsed,
      ]),
      el("div", { class: "feedback-actions" }, [submit, fb]),
    ]),
  );

  submit.addEventListener("click", async () => {
    const payload = {
      likes: likes.value.trim() || null,
      improve: improve.value.trim() || null,
      apps_used: used.value.trim() || null,
      apps_not_used: notUsed.value.trim() || null,
      sentiment: sentiment || null,
    };
    if (
      !payload.likes &&
      !payload.improve &&
      !payload.apps_used &&
      !payload.apps_not_used &&
      !payload.sentiment
    ) {
      fb.textContent = "Add at least one note or a rating.";
      return;
    }
    submit.setAttribute("disabled", "true");
    fb.textContent = "";
    try {
      await api.submitFeedback(payload);
      body.replaceChildren(
        el("div", { class: "feedback-card feedback-thanks" }, [
          el("h3", {}, ["Thank you 🙏"]),
          el("p", { class: "muted-sm" }, [
            "Your feedback is in. We read every note and act on what we can.",
          ]),
          el("a", { href: "/", "data-link": "", class: "btn btn-ghost" }, ["Back to Hub"]),
        ]),
      );
    } catch {
      fb.textContent = "Couldn't submit — try again.";
      submit.removeAttribute("disabled");
    }
  });

  return root;
}
